const pushAndGetNLatestEntries = (array, n, data) => {
  array.push(data); 
  return array.slice(-n);
}

module.exports = {
  pushAndGetNLatestEntries
}